import React from "react";
import { useHistory } from "react-router-dom";
import { Flow } from "../../../../shared/components/Flow";
import {
  PATH_BENEFITS_MERIDIO_ENROLL,
  PATH_BENEFITS_MERIDIO_EXPLORE_PLANS
} from "../../paths";
import { StepSelectPlans } from "./StepSelectPlans";
import { StepSelectCoverage } from "./StepSelectCoverage";
import { StepConfirmPlans } from "./StepConfirmPlans";
import { StepConfirmInfo } from "./StepConfirmInfo";
import { StepAddDependents } from "./StepAddDependents";
import { StepConfirmDependents } from "./StepConfirmDependents";
import { StepSetupPayment } from "./StepSetupPayment";
import { StepReviewConfirm } from "./StepReviewConfirm";
import { EnrollMeridioFlowState } from "./types";

const MERIDIO_ENROLLMENT_STORAGE_KEY = "meridio-enrollment-flow";

export const RouteEnrollMeridio: React.FC = () => {
  const history = useHistory();
  const goToExplorePlans = () =>
    history.push(PATH_BENEFITS_MERIDIO_EXPLORE_PLANS);

  const clearFlowState = () => {
    sessionStorage.removeItem(`wingspan:${MERIDIO_ENROLLMENT_STORAGE_KEY}`);
  };

  return (
    <Flow
      title="Insurance enrollment"
      basePath={PATH_BENEFITS_MERIDIO_ENROLL}
      storageKey={MERIDIO_ENROLLMENT_STORAGE_KEY}
      steps={(flowState: EnrollMeridioFlowState) => {
        const hasSetupPayment = flowState.performDeduction !== undefined;

        return [
          {
            slug: "select-plans",
            title: "Select plans",
            status: flowState.plansConfirmed ? "Complete" : undefined,
            steps: [
              {
                slug: "plans",
                title: "Select plans",
                component: StepSelectPlans
              },
              {
                slug: "coverage",
                title: "Select coverage",
                component: StepSelectCoverage
              },
              {
                slug: "confirm-plans",
                title: "Confirm plans",
                component: StepConfirmPlans
              }
            ]
          },
          {
            slug: "confirm-information",
            title: "Confirm information",
            status: flowState.informationConfirmed ? "Complete" : undefined,
            steps: [
              {
                slug: "info",
                title: "Confirm your info",
                component: StepConfirmInfo
              },
              {
                slug: "add-dependents",
                title: "Add dependents",
                component: StepAddDependents
              },
              {
                slug: "confirm-dependents",
                title: "Confirm dependents",
                component: StepConfirmDependents
              }
            ]
          },
          {
            slug: "setup-payment",
            title: "Setup payment",
            status: hasSetupPayment ? "Complete" : undefined,
            component: StepSetupPayment
          },
          {
            slug: "review",
            title: "Review & confirm",
            component: StepReviewConfirm
          }
        ];
      }}
      onBack={() => {
        clearFlowState();
        goToExplorePlans();
      }}
      onNext={() => {
        clearFlowState();
        goToExplorePlans();
      }}
    />
  );
};
